import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// const baseUrl = window.location.host.includes("localhost") ? '/tigersheet/public' : "";
// const baseUrl = window.location.host.includes("localhost") ? "" : "";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

class Base {
  static async sendRequest(
    url,
    method,
    params = {},
    body = {},
    shouldFormatBody = true,
    isFileFormat = false
  ) {
    params = params || null;
    method = method || "GET";

    const formData = new FormData();
    if (shouldFormatBody) {
      Object.keys(body).forEach((key) => {
        let value = body[key];
        if (!isFileFormat && typeof value === "object") {
          value = JSON.stringify(value);
        }

        formData.append(key, value);
      });
    }

    try {
      const response = await axios({
        method: method,
        url: baseUrl + url,
        params: params,
        data: shouldFormatBody ? formData : body,
        // withCredentials: true,
        headers: {
          // "Access-Control-Allow-Origin": "http://localhost:3000/"
        },
      });

      // console.log(response.data);
      if (!(response.data.success ?? true)) {
        throw {
          message: response?.data?.messages || "Api Failed",
          response: response.data,
        };
      }
      return response.data;
    } catch (e) {
      if (e.response.data) {
        throw {
          message: e.response?.data?.messages || "Api Failed",
          response: e.response.data,
        }
      } else {
        throw e;
      }
    }
  }
}

export default Base;
